export class FileUploadDto {
    file: number;
    constructor(file: number,) {
        this.file = file;
    }
}
